import React from "react";
import "./App.css";
import { Layout } from "antd";
import PageMenu from "./components/global/menu";
import { Outlet } from "react-router-dom";

function App() {
  return (
    <Layout style={{ height: "100vh", width: "100vw" }}>
      <Layout.Header>header</Layout.Header>
      <Layout style={{ flex: 1, overflow: "hidden" }}>
        <Layout.Sider>
          <PageMenu />
        </Layout.Sider>
        <Layout.Content style={{ overflow: "auto" }}>
          <Outlet></Outlet>
        </Layout.Content>
      </Layout>
      <Layout.Footer>footer</Layout.Footer>
    </Layout>
  );
}

export default App;
